/** @format */

import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { setMyDashboardStatus, getProducerDisputeUnreadCount } from "../../routes/marketplace/modules/marketplace";
import { useDispatch } from "react-redux";
import firebase from "../../config//firebase";

export default function ImporterSideBar({
  handleTabChanges,
  activeTab,
  lang,
  id,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [notification, setNotification] = useState(0);
  const currentUser = JSON.parse(localStorage.getItem("USER_TYPE")) ?? null;
  const userId = currentUser?.user_id;

  const route = [
    `/marketplace/my-order-view/${id}`,
    `/marketplace/offer/${id}`,
    `/marketplace/view-dispute/${id}`,
  ];

  const handleTab = (type) => {
    handleTabChanges(type);
    dispatch(setMyDashboardStatus(type));
    route?.includes(history.location.pathname) && history.push("/my-dashboard");
  };

  useEffect(()=>{
    const freeCall = async () => {
      const unreadDispute = await getProducerDisputeUnreadCount();
      if (unreadDispute?.success === 200) {
        await setNotification(unreadDispute?.producer_count);
      }
    }
    freeCall()
  }, [notification]);
  return (
    <div className="tabLeftBlock">
      <div
        className={`btn active-shadow  ${
          activeTab === "inqirey" ? "active-button" : ""
        }`}
        onClick={() => handleTab("inqirey")}
      >
        <span className="tab_icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M16.7 0C15.1625 0 14.3859 0.94375 14.325 2.125H15.2625C15.3219 1.34375 15.8375 0.85 16.6625 0.85C17.4781 0.85 18.0125 1.34688 18.0125 2.025C18.0125 2.61094 17.7594 2.96094 17.125 3.35C16.3766 3.79844 16.0312 4.29063 16.0375 5.0125V5.5125H16.9875V5.1625C16.9875 4.5875 17.1938 4.27188 17.8875 3.8625C18.5875 3.44063 19.025 2.83281 19.025 1.975C19.025 0.848438 18.0781 0 16.7 0ZM8.6125 0.8C6.7375 0.834375 5.54531 1.64219 5.025 2.85C4.52969 4 4.62031 5.44688 4.975 6.9125C4.78438 7.13594 4.63281 7.43594 4.6875 7.8875C4.74688 8.37969 4.88281 8.72969 5.075 8.975C5.18125 9.10938 5.32031 9.12188 5.45 9.1875C5.52031 9.60625 5.6375 10.025 5.8125 10.375C5.9125 10.5766 6.02656 10.7625 6.1375 10.9125C6.1875 10.9797 6.25938 11.0188 6.3125 11.075C6.31563 11.5734 6.31875 11.9844 6.275 12.5125C6.14063 12.8313 5.85156 13.0828 5.4 13.325C4.92969 13.5766 4.31875 13.8 3.7 14.0875C3.08125 14.375 2.44063 14.7359 1.9375 15.2875C1.43438 15.8391 1.08438 16.5875 1.025 17.575L1 18H16.25L16.225 17.575C16.1656 16.5875 15.8141 15.8391 15.3125 15.2875C14.8109 14.7359 14.1797 14.3766 13.5625 14.0875C12.9453 13.7984 12.3438 13.5766 11.875 13.325C11.4266 13.0828 11.1344 12.8328 11 12.5125C10.9563 11.9859 10.9594 11.5734 10.9625 11.075C11.0156 11.0172 11.0875 10.9797 11.1375 10.9125C11.2469 10.7609 11.3516 10.575 11.45 10.375C11.6203 10.025 11.7438 9.60469 11.8125 9.1875C11.9375 9.12188 12.0719 9.10625 12.175 8.975C12.3672 8.72969 12.5031 8.37969 12.5625 7.8875C12.6156 7.45 12.4688 7.16094 12.2875 6.9375C12.4828 6.30313 12.7328 5.27813 12.65 4.225C12.6047 3.65 12.4578 3.07656 12.1125 2.6C11.7875 2.15156 11.2609 1.82344 10.5875 1.7C10.1906 1.17969 9.52188 0.8 8.625 0.8H8.6125ZM8.625 1.6C8.62969 1.6 8.63281 1.6 8.6375 1.6C9.39688 1.60469 9.9 1.95469 10.075 2.2625L10.175 2.425L10.3625 2.45C10.9187 2.52813 11.2375 2.75156 11.4625 3.0625C11.6875 3.37344 11.8125 3.80781 11.85 4.2875C11.925 5.24688 11.6484 6.36406 11.475 6.8875L11.375 7.2L11.65 7.3625C11.6328 7.35156 11.8031 7.46719 11.7625 7.8C11.7156 8.19219 11.6219 8.39531 11.55 8.4875C11.4781 8.57969 11.4406 8.575 11.4375 8.575L11.1 8.6L11.0625 8.925C11.025 9.27031 10.8859 9.69375 10.725 10.025C10.6438 10.1906 10.5609 10.3359 10.4875 10.4375C10.4141 10.5391 10.3375 10.5953 10.375 10.575L10.1625 10.6875V10.925C10.1625 11.5047 10.1391 11.9797 10.2 12.65V12.7L10.225 12.75C10.4484 13.3516 10.9438 13.7328 11.4875 14.025C12.0312 14.3172 12.65 14.5437 13.225 14.8125C13.8 15.0813 14.3234 15.3953 14.7125 15.825C15.0234 16.1672 15.2312 16.625 15.3375 17.2H1.9125C2.02031 16.625 2.225 16.1672 2.5375 15.825C2.92969 15.3953 3.45938 15.0813 4.0375 14.8125C4.61563 14.5437 5.22969 14.3172 5.775 14.025C6.32031 13.7328 6.825 13.3531 7.05 12.75L7.075 12.65C7.13594 11.9797 7.1125 11.5047 7.1125 10.925V10.6875L6.9 10.575C6.93594 10.5938 6.85 10.5391 6.775 10.4375C6.7 10.3359 6.60781 10.1906 6.525 10.025C6.35938 9.69375 6.22344 9.26719 6.1875 8.925L6.15 8.6L5.8125 8.575C5.80938 8.575 5.77188 8.57969 5.7 8.4875C5.62813 8.39531 5.53438 8.19219 5.4875 7.8C5.44844 7.46719 5.61719 7.35156 5.6 7.3625L5.8625 7.2L5.7875 6.9125C5.4125 5.46563 5.35781 4.11406 5.7625 3.175C6.16563 2.23906 6.96719 1.63438 8.625 1.6ZM16.5875 6.525C16.1453 6.525 15.825 6.83906 15.825 7.2875C15.825 7.72969 16.1438 8.05 16.5875 8.05C17.0312 8.05 17.3375 7.72969 17.3375 7.2875C17.3375 6.83906 17.0297 6.525 16.5875 6.525Z"
              fill="black"
            />
          </svg>
        </span>
        <em>{lang?.ImporterInquiry}</em>
      </div>

      <div
        className={`btn active-shadow ${
          activeTab === "myOrder" ? "active-button" : ""
        }`}
        onClick={() => handleTab("myOrder")}
      >
        <span className="tab_icon">
          <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
            <g clip-path="url(#clip0_56_1813)">
              <path
                d="M0 0.124512V5.12104H0.832755V18.8754H19.1672V5.12104H20V0.124512H0ZM0.832755 0.957267H19.1672V4.28829H0.832755V0.957267ZM1.66551 5.12104H18.3331V18.0385H1.66551V5.12104ZM6.87439 6.78655C6.67766 6.77796 6.48123 6.8093 6.29694 6.87866C6.11264 6.94803 5.9443 7.05399 5.80205 7.19016C5.65981 7.32633 5.54661 7.48989 5.46927 7.67098C5.39194 7.85208 5.35207 8.04696 5.35207 8.24387C5.35207 8.44079 5.39194 8.63567 5.46927 8.81676C5.54661 8.99786 5.65981 9.16142 5.80205 9.29759C5.9443 9.43376 6.11264 9.53972 6.29694 9.60909C6.48123 9.67845 6.67766 9.70978 6.87439 9.70119H13.1201C13.3168 9.70978 13.5132 9.67845 13.6975 9.60909C13.8818 9.53972 14.0501 9.43376 14.1924 9.29759C14.3346 9.16142 14.4478 8.99786 14.5252 8.81676C14.6025 8.63567 14.6424 8.44079 14.6424 8.24387C14.6424 8.04696 14.6025 7.85208 14.5252 7.67098C14.4478 7.48989 14.3346 7.32633 14.1924 7.19016C14.0501 7.05399 13.8818 6.94803 13.6975 6.87866C13.5132 6.8093 13.3168 6.77796 13.1201 6.78655H6.87439ZM6.87439 7.61931H13.1201C13.2857 7.61931 13.4446 7.68511 13.5617 7.80224C13.6788 7.91937 13.7446 8.07823 13.7446 8.24387C13.7446 8.40952 13.6788 8.56838 13.5617 8.68551C13.4446 8.80264 13.2857 8.86844 13.1201 8.86844H6.87439C6.70875 8.86844 6.54989 8.80264 6.43276 8.68551C6.31563 8.56838 6.24983 8.40952 6.24983 8.24387C6.24983 8.07823 6.31563 7.91937 6.43276 7.80224C6.54989 7.68511 6.70875 7.61931 6.87439 7.61931Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_56_1813">
                <rect
                  width="20"
                  height="18.7509"
                  fill="white"
                  transform="translate(0 0.124512)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <em>{lang?.My_orders}</em>
      </div>
      <div
        className={`btn active-shadow ${
          activeTab === "myAddress" ? "active-button" : ""
        }`}
        onClick={() => handleTab("myAddress")}
      >
        <span className="tab_icon">
          <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
            <g clip-path="url(#clip0_2360_2888)">
              <path
                d="M10.4 1C6.87031 1 4 3.87031 4 7.4C4 9.9375 5.54531 12.8656 7.0625 15.2C8.57969 17.5344 10.1 19.2625 10.1 19.2625C10.1766 19.3484 10.2859 19.3984 10.4 19.3984C10.5141 19.3984 10.6234 19.3484 10.7 19.2625C10.7 19.2625 12.2203 17.5313 13.7375 15.2C15.2547 12.8688 16.8 9.95 16.8 7.4C16.8 3.87031 13.9297 1 10.4 1ZM10.4 1.8C13.4969 1.8 16 4.30313 16 7.4C16 9.61563 14.5453 12.4969 13.0625 14.775C11.8188 16.6844 10.7688 17.9422 10.4 18.375C10.0328 17.9422 8.98281 16.6781 7.7375 14.7625C6.25469 12.4813 4.8 9.6 4.8 7.4C4.8 4.30313 7.30313 1.8 10.4 1.8ZM10.4 4.9375L10.2 5.0625L7.2 6.8625L7.6 7.5375V10.6H13.2V7.5375L13.6 6.8625L10.6 5.0625L10.4 4.9375ZM10.4 5.8625L12.4 7.0625V9.8H11.2V7.8H9.6V9.8H8.4V7.0625L10.4 5.8625Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_2360_2888">
                <rect
                  width="20"
                  height="18.7509"
                  fill="white"
                  transform="translate(0 0.624512)"
                />
              </clipPath>
            </defs>
            /my-transactions?page=1&start_date=&end_date
          </svg>
        </span>
        <em>{lang?.My_Address}</em>
      </div>

      {/* <div
                className={`btn active-shadow  ${activeTab === "myWishList" ? "active-button" : ""}`}
                onClick={() => handleTab('myWishList')}
            >
                <span className="tab_icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_194_826)">
                            <path d="M2.40039 0.800049V19.2H13.0332C12.7082 18.9641 12.3754 18.6985 12.0598 18.4H3.20039V1.60005H16.8004V11.661C16.9973 11.625 17.1973 11.6 17.4004 11.6C17.4676 11.6 17.5348 11.6063 17.6004 11.611V0.800049H2.40039ZM5.20039 5.60005V6.40005H6.80039V5.60005H5.20039ZM8.00039 5.60005V6.40005H14.8004V5.60005H8.00039ZM5.20039 8.00005V8.80005H6.80039V8.00005H5.20039ZM8.00039 8.00005V8.80005H14.8004V8.00005H8.00039ZM5.20039 10.4V11.2H6.80039V10.4H5.20039ZM8.00039 10.4V11.2H14.8004V10.4H8.00039ZM13.8004 12.4C12.3598 12.4 11.2004 13.5422 11.2004 14.9204C11.2004 17.086 13.2004 18.386 14.4801 19.2125C14.8395 19.4485 15.1207 19.6063 15.3207 19.8047L15.5613 20L15.8004 19.8032C16.0004 19.6454 16.3207 19.4485 16.6395 19.2125C18.0004 18.3469 20.0004 17.086 20.0004 14.9204C20.0004 13.5422 18.841 12.4 17.4004 12.4C16.7207 12.4 16.0801 12.675 15.6004 13.1079C15.1207 12.675 14.4801 12.4 13.8004 12.4ZM5.20039 12.8V13.6H6.80039V12.8H5.20039ZM8.00039 12.8V13.6H10.6816C10.8113 13.3094 10.9816 13.0407 11.1863 12.8H8.00039ZM13.8004 13.1875C14.4004 13.1875 14.9207 13.475 15.2801 13.9875L15.6004 14.4L15.9207 13.9875C16.241 13.5157 16.8004 13.1875 17.4004 13.1875C18.4004 13.1875 19.2004 13.975 19.2004 14.9204C19.2004 16.6532 17.5207 17.7547 16.2801 18.5438C16.0004 18.7 15.8004 18.8579 15.6004 18.9766C15.4004 18.8188 15.2004 18.7 14.9207 18.5438C13.6801 17.7547 12.0004 16.6532 12.0004 14.9204C12.0004 13.975 12.8004 13.1875 13.8004 13.1875Z" fill="black" />
                        </g>
                        <defs>
                            <clipPath id="clip0_194_826">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </span>
                <em>My Wishlist</em>
           </div>*/}
      <div
        className={`btn active-shadow ${
          activeTab === "myOffers" ? "active-button" : ""
        }`}
        onClick={() => handleTab("myOffers")}
      >
        <span className="tab_icon">
          <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
            <g clip-path="url(#clip0_56_1813)">
              <path
                d="M3 3C1.9 3 1 3.9 1 5V13.8C1 14.9 1.9 15.8 3 15.8H17.4C18.5 15.8 19.4 14.9 19.4 13.8V5C19.4 3.9 18.5 3 17.4 3H3ZM3 3.8H17.4C18.0672 3.8 18.6 4.33281 18.6 5V13.8C18.6 14.4672 18.0672 15 17.4 15H3C2.33281 15 1.8 14.4672 1.8 13.8V5C1.8 4.33281 2.33281 3.8 3 3.8ZM11.7375 5.8C11.6062 5.82031 11.4938 5.90469 11.4375 6.025L8.2375 12.425C8.14063 12.625 8.225 12.8656 8.425 12.9625C8.625 13.0594 8.86563 12.975 8.9625 12.775L12.1625 6.375C12.2312 6.24063 12.2172 6.07813 12.1281 5.95625C12.0375 5.83438 11.8859 5.775 11.7375 5.8ZM8.2 6.2C7.54219 6.2 7 6.74219 7 7.4V7.8C7 8.45781 7.54219 9 8.2 9C8.85781 9 9.4 8.45781 9.4 7.8V7.4C9.4 6.74219 8.85781 6.2 8.2 6.2ZM8.2 7C8.42656 7 8.6 7.17344 8.6 7.4V7.8C8.6 8.02656 8.42656 8.2 8.2 8.2C7.97344 8.2 7.8 8.02656 7.8 7.8V7.4C7.8 7.17344 7.97344 7 8.2 7ZM12.2 9.8C11.5422 9.8 11 10.3422 11 11V11.4C11 12.0578 11.5422 12.6 12.2 12.6C12.8578 12.6 13.4 12.0578 13.4 11.4V11C13.4 10.3422 12.8578 9.8 12.2 9.8ZM12.2 10.6C12.4266 10.6 12.6 10.7734 12.6 11V11.4C12.6 11.6266 12.4266 11.8 12.2 11.8C11.9734 11.8 11.8 11.6266 11.8 11.4V11C11.8 10.7734 11.9734 10.6 12.2 10.6Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_56_1813">
                <rect
                  width="20"
                  height="18.7509"
                  fill="white"
                  transform="translate(0 0.124512)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <em>{lang?.My_offers}</em>
      </div>
      <div
        className={`btn active-shadow disputeList ${
          activeTab === "Disputes" ? "active-button" : ""
        }`}
        onClick={() => handleTab("Disputes")}
      >
        <div className="listItem">
          <span className="tab_icon">
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
              <g clip-path="url(#clip0_56_1813)">
                <path
                  d="M3 3C1.9 3 1 3.9 1 5V13.8C1 14.9 1.9 15.8 3 15.8H17.4C18.5 15.8 19.4 14.9 19.4 13.8V5C19.4 3.9 18.5 3 17.4 3H3ZM3 3.8H17.4C18.0672 3.8 18.6 4.33281 18.6 5V13.8C18.6 14.4672 18.0672 15 17.4 15H3C2.33281 15 1.8 14.4672 1.8 13.8V5C1.8 4.33281 2.33281 3.8 3 3.8ZM11.7375 5.8C11.6062 5.82031 11.4938 5.90469 11.4375 6.025L8.2375 12.425C8.14063 12.625 8.225 12.8656 8.425 12.9625C8.625 13.0594 8.86563 12.975 8.9625 12.775L12.1625 6.375C12.2312 6.24063 12.2172 6.07813 12.1281 5.95625C12.0375 5.83438 11.8859 5.775 11.7375 5.8ZM8.2 6.2C7.54219 6.2 7 6.74219 7 7.4V7.8C7 8.45781 7.54219 9 8.2 9C8.85781 9 9.4 8.45781 9.4 7.8V7.4C9.4 6.74219 8.85781 6.2 8.2 6.2ZM8.2 7C8.42656 7 8.6 7.17344 8.6 7.4V7.8C8.6 8.02656 8.42656 8.2 8.2 8.2C7.97344 8.2 7.8 8.02656 7.8 7.8V7.4C7.8 7.17344 7.97344 7 8.2 7ZM12.2 9.8C11.5422 9.8 11 10.3422 11 11V11.4C11 12.0578 11.5422 12.6 12.2 12.6C12.8578 12.6 13.4 12.0578 13.4 11.4V11C13.4 10.3422 12.8578 9.8 12.2 9.8ZM12.2 10.6C12.4266 10.6 12.6 10.7734 12.6 11V11.4C12.6 11.6266 12.4266 11.8 12.2 11.8C11.9734 11.8 11.8 11.6266 11.8 11.4V11C11.8 10.7734 11.9734 10.6 12.2 10.6Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_56_1813">
                  <rect
                    width="20"
                    height="18.7509"
                    fill="white"
                    transform="translate(0 0.124512)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <em>Disputes</em>
        </div>
        {notification > 0
                      ? <div className="noCount">{notification}</div>
            : ""}
      </div>
    </div>
  );
}
